import { render, staticRenderFns } from "./TranslationInfo.vue?vue&type=template&id=72b9bd7f&"
import script from "./TranslationInfo.vue?vue&type=script&lang=ts&"
export * from "./TranslationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b9bd7f')) {
      api.createRecord('72b9bd7f', component.options)
    } else {
      api.reload('72b9bd7f', component.options)
    }
    module.hot.accept("./TranslationInfo.vue?vue&type=template&id=72b9bd7f&", function () {
      api.rerender('72b9bd7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TranslationInfo.vue"
export default component.exports